export default "__VITE_ASSET__DgLXaRSB__"